import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT_V2 = `${CONS.API_ENDPOINT_BACK_NODE}/imagenes`

export const subirImagenes = (body) => {
  return http.post(`${API_ENDPOINT_V2}/subirImagenes`, body)
}

export const buscarImagenes = (body) => {
  return http.post(`${API_ENDPOINT_V2}/buscarImagenes`, body)
}

export const obtenerImagen = (body) => {
  return http.post(`${API_ENDPOINT_V2}/obtenerImagen`, body, {
    responseType: 'blob'
  })
}

export const borrarImagen = (idAdjunto) => {
  return http.post(`${API_ENDPOINT_V2}/borrarImagen`, { idAdjunto })
}
